import React from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import Link from 'redux-first-router-link'
import { doOpenNewTicketPage } from 'actions/pages'
import themeVars from 'ui_theme/site/globals/site.variables'
import { Button } from 'util/ui'
import { Icon } from 'shared/ui'

const CreateIcon = styled(Icon)`
  height: 13px;
  width: 13px;
  font-size: 13px;
  margin-right: 4px;
  color: inherit;
  transform: translateY(-1px);

  &:hover {
    color: inherit;
  }
`

export default function NewTicketButton(props) {
  const { className } = props
  return (
    <Link className={className} to={doOpenNewTicketPage()}>
      <Button
        color={themeVars.groovyColorName}
        size="small"
        css={css`
          &&& {
            display: flex;
            align-items: center;
            margin: 0;
          }
        `}
      >
        <CreateIcon name="create" /> New Conversation
      </Button>
    </Link>
  )
}
